export { default } from './AppVersionLabel'
